
/**
 * @param {?} event
 * @return {?}
 */
export function numberDelimiter(event: any): string {
  const /** @type {?} */ numberToString = event === 0 || event ? event.toString() : '';
  const /** @type {?} */ storeNumber = numberToString.replace(/[^0-9]/g, '');

  let /** @type {?} */ separatedNumber;
  if (storeNumber !== '' && storeNumber !== null) {
    separatedNumber = parseInt(storeNumber).toLocaleString('id-ID');
  } else {
    separatedNumber = '';
  }

  return separatedNumber;
}
